export default __webpack_public_path__ + "static/media/ELC.3cc0cf44.png";